import { Box, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";

const NotFoundPage = () => (
  <Box
    sx={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      gap: 2,
      p: 3,
    }}
  >
    <Typography variant="h2" component="h1" sx={{ color: "#1C4E50" }}>
      404
    </Typography>
    <Typography variant="h5" component="h2">
      Page Not Found
    </Typography>
    <Typography variant="body1">
      The page you are looking for does not exist or has been moved.
    </Typography>
    <Button
      component={Link}
      to="/"
      variant="contained"
      sx={{ backgroundColor: "#1C4E50", "&:hover": { backgroundColor: "#163d3f" } }}
    >
      Go to Home
    </Button>
  </Box>
);

export default NotFoundPage;
